import { Injectable } from '@angular/core';
import { SessionService } from './session.service';
import { SnackBarService } from './snackbar.service';
import { Respuesta } from '../_models/shared/_index';
import { Router } from '@angular/router';
import { HttpErrorResponse } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { MatDialogRef, MatDialog } from '@angular/material/dialog';
import { MatSnackBarConfig, MatSnackBarRef } from '@angular/material/snack-bar';
import { AlertComponent } from '../dialogs';
import { ReingresarDialog } from '../dialogs/reingresar-dialog/reingresar-dialog.component';

@Injectable()
export class ErrorService {
	constructor(
		private sessionService: SessionService,
		private snackBarService: SnackBarService,
		private dialog: MatDialog,
		private router: Router
	) {}

	reingresarDialogRef: MatDialogRef<ReingresarDialog>;
	public handleError<T>(operation = 'operation', result?: T) {
		return (error: HttpErrorResponse): Observable<Respuesta> => {
			// TODO: mandar el error hacia la infraestructura de logueo remota

			// Checkeo si el error es de Authentication
			if (error.status == 401) {
				if (!this.sessionService.getCurrentUser()) {
					this.router.navigate(['/login']);
				} else if (!this.sessionService.getCurrentUser().perfil) {
				} else {
					this.snackBarService.openSnackBar(
						false,
						'Sesión Expirada',
						'Reingrese y vuelva a intentar',
						false,
						3000
					);
					this.abrirDialogReingreso();
				}
				// Checkeo si el error es de Authorization
			} else if (error.status == 403) {
				this.snackBarService.openSnackBar(
					false,
					'Recurso protegido',
					'No tiene permiso para utilizar este recurso',
					false,
					3000
				);
				//Si el error es desconocido
			} else {
				this.snackBarService.openSnackBar(
					false,
					'ERROR' + (error.status ? ' HTTP(' + error.status + ')' : ''),
					error.statusText,
					false,
					3000
				);
			}

			console.error(error);
			console.log(`${operation} failed: ${error.message}`);
			// permitir que la aplicacion siga funcionando regresando un resultado vacio.
			return of(new Respuesta());
		};
	}

	CheckResponse(
		res: Respuesta,
		overrideError: { title: string; error: string } = undefined,
		redireccionar: boolean = false
	) {
		if (!res.Succeed) {
			//capturo el id del error para pegarlo en el title;
			let errorCode = res.Code ? ' (' + res.Code + ')' : '';
			//Utilizo el titulo Error o el recibido por parametro mas el codigo/id obtenido;
			let title =
				(overrideError && overrideError.title ? overrideError.title : 'Error') +
				errorCode;
			//Utilizo el la descripcion devuelta por el backend o la recibido por parametro;
			let error =
				overrideError && overrideError.error
					? overrideError.error
					: res.Message;
			this.snackBarService.openSnackBar(false, title, error, false, 3000);
		}
	}

	abrirDialogReingreso() {
		if (!this.reingresarDialogRef) {
			this.reingresarDialogRef = this.dialog.open(ReingresarDialog, {});
			this.reingresarDialogRef.afterClosed().subscribe((result) => {
				this.reingresarDialogRef = undefined;
			});
		}
	}
}
